import type { ReactNode } from "react";
import { guardianDenialFromError } from "@bw/shared/api";
import { GuardianDenialNotice } from "./GuardianDenialNotice";

/**
 * A mutation's error area: the shared guardian notice (with its Ask flow) for a
 * guardian-control 403, otherwise the caller's generic error.
 */
export function GuardianAwareError({
  error,
  children,
}: {
  error: unknown;
  children: ReactNode;
}) {
  const denial = guardianDenialFromError(error);
  if (!denial) return <>{children}</>;
  // Keyed so a different denial starts its own Ask flow.
  return (
    <GuardianDenialNotice
      key={`${denial.code}:${denial.control ?? ""}:${denial.subject?.id ?? ""}`}
      denial={denial}
    />
  );
}
